import { render, staticRenderFns } from "./productLimit.vue?vue&type=template&id=1ac8b372&scoped=true&"
import script from "./productLimit.vue?vue&type=script&lang=js&"
export * from "./productLimit.vue?vue&type=script&lang=js&"
import style0 from "./productLimit.vue?vue&type=style&index=0&id=1ac8b372&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac8b372",
  null
  
)

export default component.exports